import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import UploadPage from "@/pages/UploadPage";
import TransactionsPage from "@/pages/TransactionsPage";
import DownloadsPage from "@/pages/DownloadsPage";
import AccountsPage from "@/pages/AccountsPage";
import AccountDetailPage from "@/pages/AccountDetailPage";
import ReconciliationPage from "@/pages/ReconciliationPage";
import UploadHistoryPage from "@/pages/UploadHistoryPage";
import SalarySlipsPage from "@/pages/SalarySlipsPage";
import BusinessTransactionsPage from "@/pages/BusinessTransactionsPage";
import BusinessReconciliationPage from "@/pages/BusinessReconciliationPage";
import BusinessUploadPage from "@/pages/BusinessUploadPage";
import BusinessUploadHistoryPage from "@/pages/BusinessUploadHistoryPage";
import BusinessDashboardPage from "@/pages/BusinessDashboardPage";
import BusinessAccountsPage from "@/pages/BusinessAccountsPage";
import BusinessDownloadsPage from "@/pages/BusinessDownloadsPage";
import Sidebar from "@/components/Sidebar";
import { Toaster } from "sonner";

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-[#F7F6F2] flex items-center justify-center">
      <div className="text-[#5C5C55] text-sm">Loading...</div>
    </div>
  );
}

function ProtectedLayout() {
  const { user, loading } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="flex h-screen bg-[#F7F6F2]">
      <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
      <main className="flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/downloads" element={<DownloadsPage />} />
          <Route path="/accounts" element={<AccountsPage />} />
          <Route path="/accounts/:accountId" element={<AccountDetailPage />} />
          <Route path="/reconciliation" element={<ReconciliationPage />} />
          <Route path="/upload-history" element={<UploadHistoryPage />} />
          <Route path="/salary-slips" element={<SalarySlipsPage />} />
          <Route path="/business/transactions" element={<BusinessTransactionsPage />} />
          <Route path="/business/reconciliation" element={<BusinessReconciliationPage />} />
          <Route path="/business/upload" element={<BusinessUploadPage />} />
          <Route path="/business/upload-history" element={<BusinessUploadHistoryPage />} />
          <Route path="/business/dashboard" element={<BusinessDashboardPage />} />
          <Route path="/business/accounts" element={<BusinessAccountsPage />} />
          <Route path="/business/downloads" element={<BusinessDownloadsPage />} />
        </Routes>
      </main>
    </div>
  );
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen />;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/*" element={<ProtectedLayout />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontFamily: "'IBM Plex Sans', system-ui, sans-serif",
              fontSize: '13px',
              borderRadius: '6px',
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
